import moment from 'moment'
import { GetRequest } from '@/utils/util'
// 获取vue实例
let vm = null;
const getInstance = (e) => {
    vm = e
}

// iframe高度自适应
/* function setHeight(iframe) {
        if (iframe) {
            var iframeWin = iframe.contentWindow || iframe.contentDocument.parentWindow;
            if (iframeWin.document.body) {
                iframe.height = iframeWin.document.documentElement.scrollHeight || iframeWin.document.body.scrollHeight;
            }
        }
    };
    window.onload = function () {
    setIframeHeight(document.getElementById('external-frame'));
}; */

// 弹窗
function openStationWindow({map, point, station, timeType, dataType, showChilds, valueTime, calied_type, loadSnapStatus, wind, city}) {
    let url = ''
    if (process.env.DOCK_ENV) {
        let pathname = GetRequest('pathname') 
        url = `${pathname}static/wz_station_detail/dist/index.html?station_id=${station.station_id}&uid=1526&showMap=0&timep=${timeType}&data_type=${dataType}&t=${station.data.time}&show_childs=${showChilds}&data_calied_type=${calied_type}&city=${city}&pathname=${pathname}`
    } else {
        url = `/yangchen_station/?station_id=${station.station_id}&uid=1526&showMap=0&timep=${timeType}&data_type=${dataType}&t=${station.data.time}&show_childs=${showChilds}&data_calied_type=${calied_type}&city=${city}`
    }
  if (!loadSnapStatus) {
    url += `&start=${moment(valueTime[0]).unix()}&end=${moment(valueTime[1]).unix()}`
  }
  if(wind) {
    url += `&wind=1`
  }
    let iframe = `<iframe id="external-frame" width="100%" height="580px" src="`
      + url  
     + `" frameborder="0"></iframe>`
    let content=`
        <div class="panel panel-primary" style="position: relative">
            ${iframe}
        </div>`
    let infoWindow = new BMap.InfoWindow(content,
    {
        width : 570,
        height: 590,
    }
    )
    infoWindow.addEventListener('close', ()=>{
        
    })
    map.openInfoWindow(infoWindow, point)


    /* if(!infoWindow.isOpen()) {
        infoWindow.addEventListener("open", (e) => {
            const btn = document.getElementById('infowindowbtn')
            btn.onclick = () => {
              // vm.showBigStationDialog = true;
              document.getElementById("external-frame")
            }
        })
    } else {
        const btn = document.getElementById('infowindowbtn')
        btn.onclick = () => {
            vm.showBigStationDialog = true;
        }
    } */

    // 最大化
    window.addEventListener("message", function(e) {
        const isLarge = e.data.isLarge
        console.log(typeof isLarge)
        if(isLarge) {
            const iframeWin =  document.getElementById('external-frame')
            iframeWin.style.position = "fixed"
            iframeWin.style.left = "469px"
            iframeWin.style.top = 0
            iframeWin.style.zIndex = 1000000000
            iframeWin.height = "657"
            iframeWin.width = "1440"
            iframeWin.style.background = "white"
            iframeWin.style.padding = "10px"
            // infoWindow.maximize()
            // infoWindow.setWidth(1500)
            // infoWindow.setHeight(657)
            // infoWindow.redraw()
        } else {
            const iframeWin =  document.getElementById('external-frame')
            iframeWin.style.position = "relative"
            iframeWin.style.left = 0
            iframeWin.style.top = 0
            iframeWin.style.zIndex = 1
            iframeWin.height = "580"
            iframeWin.width = "100%"
            iframeWin.style.background = "white"
            iframeWin.style.padding = 0
        }
    })
}

export {
    openStationWindow,
    getInstance
}


// WEBPACK FOOTER //
// ./src/utils/open_station_window.js